import { createFileRoute } from '@tanstack/react-router';
import { LaColaborativa } from '../pages/LaColaborativa';

export const Route = createFileRoute('/la-colaborativa')({ component: LaColaborativa });
